<template>
  <div>
    <v-list
      id="cartItemList"
      flat
      subheader
      class="cart-item-list"
      :class="{ 'checkout-item-list': isCheckout }"
    >
      <template>
        <v-subheader
          class="text-caption d-flex align-center justify-space-between default--text"
        >
          <CartItemCount :count="cart.totalItems" />
          <!-- <v-btn
            color="primary"
            plain
            class="empty-cart-btn d-md-none d-lg-none"
            @click="emptyCartConfirm"
            >{{ $t("cart.emptyCart") }}</v-btn
          > -->
          <v-switch
            v-model="showSectors"
            label="Dividi per categoria"
            hide-details
            class="mt-0 pt-0"
          ></v-switch>
        </v-subheader>
      </template>

      <!-- Collapse/Expand Toggle -->
      <v-subheader class="d-flex justify-end align-center" v-if="showSectors">
        <v-btn
          color="primary"
          depressed
          small
          outlined
          @click="
            collapseAll = !collapseAll;
            togglePanels();
          "
        >
          {{
            collapseAll ? $t("checkout.expandAll") : $t("checkout.collapseAll")
          }}
        </v-btn>
      </v-subheader>

      <div
        v-if="!showSectors"
        class="no-sectors"
        :class="[
          { 'cart-item-list-no-checkout': !isCheckout },
          { 'cart-item-list-no-checkout-higher': !isCheckout }
        ]"
      >
        <div
          v-for="cartItem in cart.cartItems"
          :key="cartItem.cartItemId"
          class="align-center px-md-2"
        >
          <CartItem :item="cartItem" :full="full" :isCheckout="isCheckout" />
        </div>
      </div>

      <v-expansion-panels v-else v-model="panel" accordion flat multiple tile>
        <v-expansion-panel
          v-for="([categoryId, group], index) in itemGroups"
          :key="categoryId"
        >
          <v-expansion-panel-header
            v-on:click.prevent="() => {}"
            class="text-caption primary--text grey lighten-2 px-3"
          >
            <div class="d-flex align-center">
              <span class="font-weight-bold mr-2">{{ group.name }}</span>
              <span>
                {{ `${$tc("lists.products", group.products.length)}` }}
              </span>
            </div>
            <template v-slot:actions>
              <v-icon color="primary" x-small>
                {{ panel.includes(index) ? "$minus" : "$plus" }}
              </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <CartItem
              class="sectorItem"
              v-for="item in group.products"
              :key="item.itemId"
              :item="item"
              :full="full"
              :isCheckout="isCheckout"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-list>
  </div>
</template>
<style lang="scss">
.cart-item-list {
  .v-input--switch {
    .v-label {
      color: var(--v-primary-base) !important;
    }
  }
  .v-expansion-panel {
    .v-expansion-panel-header {
      min-height: 20px;
      padding: 10px 24px;
    }
    .v-expansion-panel-content .v-expansion-panel-content__wrap {
      padding: 0px !important;
      .v-list-item {
        padding: 0 16px;
        min-height: 70px;
        max-height: 145px;
      }
    }
  }
  .checkout-item-list {
    .no-sectors {
      .v-list-item {
        min-height: 70px !important;
        padding: 8px 0px;
      }
    }
  }
  .v-subheader {
    height: auto;
    min-height: #{$list-subheader-min-height};
    background: linear-gradient(
      #eeeeee 0% #eeeeee 80%,
      rgba(238, 238, 238, 0.7) 100%
    );
  }
  .cart-item-list-no-checkout {
    min-height: 30vh;
    height: calc(
      100vh - (#{$cart-info-height} + #{$list-subheader-min-height}) - 80px
    );
    padding-bottom: #{$summary-height};
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--v-grey-darken2);
      border-radius: 20px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .cart-item-list-no-checkout-higher {
    height: calc(
      100vh -
        (
          #{$cart-info-height} + #{$list-subheader-min-height} + #{$cartlist-diff}
        )
    ) !important;
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .cart-item-list-no-checkout {
      min-height: auto;
      max-height: 100%;
    }
  }
}
</style>

<script>
import CartItem from "./CartItem.vue";
import CartItemCount from "./CartItemCount.vue";
import AnalyticsService from "~/service/analyticsService";
import { mapActions, mapState } from "vuex";

export default {
  name: "CartItemList",
  components: { CartItem, CartItemCount },
  props: {
    full: { type: Boolean, default: false },
    isCheckout: { type: Boolean, default: false },
    checkMobile: { type: Boolean, default: false },
    showSectors: { type: Boolean, default: true },
    itemListName: { type: String, required: false }
  },
  data() {
    return {
      panel: [],
      collapseAll: false
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    allPanelIndices() {
      return Array.from(this.itemGroups.keys()).map((_, i) => i);
    },
    acceptAlternatives: {
      get() {
        let value = true;
        this.cart.cartItems.forEach(cartItem => {
          if (cartItem.cartItemInfo.accept_alternatives != "true") {
            value = false;
          }
          return value;
        });
        return value;
      },
      set(value) {
        this.setCartItemInfo({
          items: this.cart.cartItems,
          name: "accept_alternatives",
          value: "" + value
        });
      }
    },
    orderComment: {
      get() {
        return this.cart.cartInfos.order_comment;
      },
      set(value) {
        console.log(value);
      }
    },
    itemGroups() {
      const groups = new Map();
      if (this.cart.cartItems) {
        this.cart.cartItems.forEach(item => {
          let category = this.$store.getters["category/lookupCategory"](
            item.product.categoryId
          );
          if (!category) {
            category = { categoryId: -1, name: "Senza categoria" };
          }
          if (groups.has(category.categoryId)) {
            groups.get(category.categoryId).products.push(item);
          } else {
            groups.set(category.categoryId, {
              name: category.name,
              products: [item]
            });
          }
        });
      }
      return groups;
    }
  },
  methods: {
    handleRemove() {},
    changeTimeslot() {},
    changeDelivery() {},
    ...mapActions({
      // emptyCart: "cart/emptyCart",
      setCartItemInfo: "cart/setCartItemInfo",
      setCartInfo: "cart/setCartInfo"
    }),
    togglePanels() {
      if (this.collapseAll) {
        // collapse all
        this.panel = [];
      } else {
        // expand all
        this.panel = Array.from(this.itemGroups.keys()).map(
          (_, index) => index
        );
      }
    }
    // async emptyCartConfirm() {
    //   if (this.cart.totalItems > 0) {
    //     let res = await global.vm.$dialog.confirm({
    //       text: global.vm.$t("message.emptyCart")
    //     });
    //     if (res) {
    //       this.emptyCart();
    //     }
    //   }
    // }
  },
  mounted() {
    // Expand all panels by default
    this.panel = Array.from(this.itemGroups.keys()).map((_, index) => index);
  },
  created() {
    AnalyticsService.viewProducts(this.cart.cartItems, this.itemListName, 0);
  }
};
</script>
